import { useTranslation } from 'react-i18next';
import { dateFormatter, NavigationItem } from '@asset-metrix/portal-ui';

export type DataRefreshDateNavigationItemProps = {
  collapsed: boolean;
  timestamp: string;
};

export function DataRefreshDateNavigationItem({
  collapsed,
  timestamp,
}: DataRefreshDateNavigationItemProps) {
  const formattedDate = dateFormatter(timestamp, {
    dateFormat: 'fullMonthDayYearWithTime',
  });
  const { t } = useTranslation();
  return formattedDate != null ? (
    <NavigationItem
      collapsed={collapsed}
      iconName="info"
      label={t('app.dataRefresh.label')}
      sublabel={formattedDate}
      tooltip={t('app.dataRefresh.tooltip', {
        formattedDate,
        interpolation: {
          escapeValue: false,
        },
      })}
    />
  ) : null;
}
